'use client';

import AppLayout from '@/components/AppLayout';
import RouteGuard from '@/components/RouteGuard';
import DocumentsContent from './components/DocumentsContent';

export default function DocumentsPage() {
  return (
    <RouteGuard allowedRoles={['Administrateur', 'Broker']} redirectTo="/liste-des-locaux">
      <AppLayout currentPath="/documents">
        <DocumentsContent />
      </AppLayout>
    </RouteGuard>
  );
}
